import { Dispatch, SetStateAction } from "react";
import {
  API_URL,
  put,
  v,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from "../../lib";
import { doREQUEST_COMPLETE, doREQUEST_ERROR } from "../state";
import { getToken } from "./token_fetcher";
import { Action } from "redux";

export const REQUEST_IDENTITY_ANNOUNCEMENT_READ = "REQUEST_IDENTITY_ANNOUNCEMENT_READ";
export const doREQUEST_IDENTITY_ANNOUNCEMENT_READ = createDoRequestAction(
  REQUEST_IDENTITY_ANNOUNCEMENT_READ,
);

export const requestIdentityAnnouncementReadActionCreators = {
  doREQUEST_IDENTITY_ANNOUNCEMENT_READ,
};

interface Payload extends Action {
  payload: {
    requestId: string;
    announcementId: string;
  };
  setRequestResult: Dispatch<SetStateAction<RequestResult | null>>;
}

export function* requestIdentityAnnouncementRead({
  payload,
  setRequestResult,
}: Payload): SagaIterator {
  debug("saga*requestIdentityAnnouncementRead");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        announcementId: v.string().uuid().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_ANNOUNCEMENT_READ,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const accessToken = yield call(getToken);
  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/identity-announcement-read`,
    accessToken,
    data: {
      identityAnnouncementId: payload.announcementId,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_ANNOUNCEMENT_READ,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/identity-announcement-read",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_IDENTITY_ANNOUNCEMENT_READ,
        fromPayload: payload,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* identityAnnouncementReadSaga() {
  yield takeEvery(REQUEST_IDENTITY_ANNOUNCEMENT_READ, requestIdentityAnnouncementRead);
}
